import React, { useCallback, useEffect, useState } from 'react'
import { FormikTabButtonGroup } from 'src/Libs/inputs/formik/index'
import { useField, useFormikContext } from 'formik'
import { isUndefined } from 'lodash'

export interface Props {
  name: string
  onChange?: (index: number) => void
  disabled?: boolean
  fullWidth?: boolean
  actions: { label: string; value: string }[]
}

const Toggle: React.FC<Props> = ({ name, disabled = false, fullWidth = false, actions, onChange }) => {
  const [field] = useField(name)
  const { setFieldValue } = useFormikContext()
  const [currentActive, setCurrentActive] = useState<number>(actions.findIndex(item => item.value === field.value))

  const onOffActions = actions.map((values, index) => ({ id: `${name}-${index}`, label: values.label }))

  useEffect(() => {
    if (isUndefined(field.value)) {
      return
    }
    const nextIndex = actions.findIndex(item => item.value === field.value)

    if (nextIndex !== currentActive) {
      setCurrentActive(nextIndex)
    }
  }, [field.value, currentActive, actions]) //eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = useCallback(
    (activeIndex: number) => {
      setCurrentActive(activeIndex)

      const fieldValue = actions.find((_, index) => index === activeIndex)?.value || false

      setFieldValue(name, fieldValue)
      onChange?.(activeIndex)
    },
    [name, actions, setFieldValue] //eslint-disable-line react-hooks/exhaustive-deps
  )

  return <FormikTabButtonGroup active={currentActive} onChange={handleChange} actions={onOffActions} disabled={disabled} fullWidth={fullWidth} />
}

export default Toggle
